{
	"pageTitle": "Myy kiekko",
	"pageSubtitle": "Luo ilmoitus 4 nopeassa vaiheessa.",
	"steps": {
		"photos": "Kuvat & värit",
		"discIdentity": "Kiekon tiedot",
		"flightCondition": "Lennot & kunto",
		"logistics": "Logistiikka"
	},
	"published": {
		"title": "Kiekkosi on myynnissä!",
		"description": "Ostajat voivat löytää sen nyt.",
		"addAnother": "Myy toinen kiekko",
		"viewListing": "Näytä ilmoitus"
	},
	"wizard": {
		"stepMeta": {
			"0": {
				"eyebrow": "Aloita tästä",
				"title": "Kiekon\nkuvat",
				"sub": "Hyvät kuvat myyvät nopeammin — lisää vähintään yksi"
			},
			"1": {
				"eyebrow": "Kiekon tiedot",
				"title": "Kiekon\nmalli",
				"sub": "Hae nimellä — kiekkotyyppi täyttyy automaattisesti"
			},
			"2": {
				"eyebrow": "Kiekon tiedot",
				"title": "Kiekko-\ntyyppi",
				"sub": "Vahvista tai muuta kiekkotyyppi ja paino"
			},
			"3": {
				"eyebrow": "Materiaali",
				"title": "Muovin\ntyyppi",
				"sub": "Valitse muoviseos"
			},
			"4": {
				"eyebrow": "Kunto",
				"title": "Arvioi\nkiekko",
				"sub": "Kuinka kulunut tämä kiekko on?"
			},
			"5": {
				"eyebrow": "Lentoprofiili",
				"title": "Lento-\nnumerot",
				"sub": "Syötä lentonumerot jos tiedät — vapaaehtoinen"
			},
			"6": {
				"eyebrow": "Vapaaehtoinen",
				"title": "Mitä\nmuuta?",
				"sub": "Kuvaile kuntoa, merkkejä tai erityisiä ominaisuuksia…"
			},
			"7": {
				"eyebrow": "Melkein valmis",
				"title": "Hinta &\nsijainti",
				"sub": "Aseta myyntihinta ja noutoalue"
			},
			"8": {
				"eyebrow": "Kaikki valmista",
				"title": "Tarkista\nilmoitus",
				"sub": "Muokkaa mitä tahansa ennen julkaisemista"
			}
		},
		"reviewLabel": "Tarkistus",
		"discard": {
			"title": "Hylkää ilmoitus?",
			"description": "Menetät lisäämäsi kuvat ja tiedot.",
			"confirm": "Hylkää",
			"cancel": "Jatka muokkaamista"
		},
		"aria": {
			"close": "Sulje ohjattu toiminto",
			"previousStep": "Edellinen vaihe"
		}
	},
	"step1": {
		"stepLabel": "Vaihe 1 / 4",
		"title": "Kuvat & värit",
		"description": "Lisää kuvat kiekostasi ja valitse värit.",
		"photos": {
			"label": "Kuvat",
			"hint": "Ylänäkymä vaaditaan · muut vapaaehtoisia",
			"topRequired": "Ylänäkymäkuva vaaditaan.",
			"topView": "Ylänäkymä",
			"sideView": "Sivunäkymä",
			"bottomView": "Alanäkymä",
			"extra": "Lisäkuva",
			"editCrop": "Muokkaa {{label}} rajausta",
			"cropEditorLabel": "{{label}} rajaustyökalu",
			"previewAlt": "{{label}} esikatselu",
			"zoom": "Zoom",
			"zoomLabel": "{{label}} zoom",
			"rotation": "Kierto",
			"rotationLabel": "{{label}} kierto",
			"remove": "Poista {{label}}",
			"upload": "Lataa {{label}}",
			"editing": "Muokkaus",
			"crop": "Rajaa",
			"add": "Lisää",
			"uploading": "Ladataan…",
			"cropInstruction": "Panoroi ja zoomaa kiekko ympyrän keskelle",
			"discardImage": "Hylkää kuva"
		},
		"colors": {
			"label": "Kiekon värit",
			"selectAtLeast": "valitse vähintään yksi",
			"fromPhoto": "· kuvasta",
			"required": "Valitse vähintään yksi väri.",
			"dyedHint": "värjätty tai tie-dye",
			"selectedCount": "{{count}} valittu",
			"selectedAriaLabel": "Valittu: {{colors}}"
		}
	},
	"step2": {
		"stepLabel": "Vaihe 2 / 4",
		"title": "Kiekon tiedot",
		"description": "Hae kiekkosi mallia täyttääksesi lennot automaattisesti.",
		"disc": "Kiekko",
		"searchPlaceholder": "Hae kiekkoa…",
		"notListed": "Kiekkoni ei ole listalla",
		"searchInstead": "Hae sen sijaan",
		"manufacturer": "Valmistajan nimi",
		"manufacturerPlaceholder": "esim. Innova",
		"discModel": "Kiekon mallinimi",
		"discModelPlaceholder": "esim. Destroyer",
		"discClass": "Kiekkotyyppi",
		"selectDiscClass": "Valitse kiekkotyyppi…",
		"discClasses": {
			"putter": "Putteri",
			"midrange": "Midrange",
			"fairway-driver": "Fairway-draiveri",
			"distance-driver": "Distance-draiveri"
		},
		"classHints": {
			"distance-driver": "Maksimikantama teeltä",
			"fairway-driver": "Tarkkuus + kantama",
			"midrange": "Hallinta & lähestyminen",
			"putter": "Lähipeli & putit"
		},
		"plasticType": "Muovityyppi",
		"selectPlasticType": "Valitse muovityyppi...",
		"weight": "Paino (g)",
		"weightPlaceholder": "175",
		"weightSlider": "Paino",
		"weightCommonRange": "yleisin: 150–180g",
		"autoFilledBanner": "Automaattisesti täytetty: {{model}}",
		"unknownManufacturer": "Tuntematon",
		"clearSearch": "Tyhjennä haku",
		"manufacturerPlastics": "{{manufacturer}} — muovit",
		"plasticNotApplicable": "Ei sovellu omille kiekoille",
		"plasticNotApplicableHint": "Muovityypin haku vaatii valmistajan tietokannasta. Voit ohittaa tämän vaiheen.",
		"plasticLoadingHint": "Valitse ensin kiekon malli ladataksesi muovivaihtoehdot.",
		"plasticLoading": "Ladataan muoveja…",
		"noDiscsFound": "Kiekkoja ei löytynyt.",
		"typeToSearch": "Kirjoita hakuun…",
		"errors": {
			"selectDisc": "Hae ja valitse kiekon malli.",
			"enterManufacturer": "Anna valmistajan nimi.",
			"enterDiscModel": "Anna kiekon mallinimi.",
			"selectClass": "Valitse kiekkotyyppi.",
			"invalidWeight": "Anna kelvollinen paino grammoina (esim. 175)."
		}
	},
	"step3": {
		"stepLabel": "Vaihe 3 / 4",
		"title": "Lennot & kunto",
		"description": "Tarkista viralliset numerot, säädä kulumisen mukaan ja arvioi kiekko.",
		"officialFlight": "Viralliset lentonumerot",
		"estimatedFlight": "Arvioidut lentonumerot",
		"estimatedFlightHint": "Miten kiekko lentää kulutuksen jälkeen? Kulunut kiekko lentää eri tavalla kuin viralliset numerot – säädä, jotta ostaja tietää mitä oikeasti saa.",
		"speed": "Nopeus",
		"glide": "Liito",
		"turn": "Vakaus",
		"fade": "Feidi",
		"condition": "Kunto",
		"conditions": {
			"9": "Kuin uusi",
			"8": "Erinomainen",
			"7": "Hyvä",
			"6": "Kohtalainen",
			"5": "Käytetty",
			"1-3": "Kulunut"
		},
		"conditionDescriptions": {
			"9": "Käytännössä ei jälkiä, heitetty tuskin",
			"8": "Vain kevyitä naarmuja, lentää kuin uusi",
			"7": "Näkyvää kulumaa, pieniä jälkiä",
			"6": "Huomattavia naarmuja ja kolhuja",
			"5": "Raskasta kulumaa, vielä lennettävä",
			"1-3": "Täysin kulunut — lento muuttunut"
		},
		"descriptionLabel": "Kuvaus",
		"descriptionAriaLabel": "Kiekon kuvaus",
		"optional": "Vapaaehtoinen",
		"descriptionPlaceholder": "Kuvaile värimerkit, vauriot tai erityiset lento-ominaisuudet.",
		"increase": "Kasvata {{label}}",
		"decrease": "Pienennä {{label}}",
		"errors": {
			"selectCondition": "Valitse kunto."
		}
	},
	"step4": {
		"stepLabel": "Vaihe 4 / 4",
		"title": "Logistiikka",
		"description": "Aseta hinta, toimitus ja yhteystietosi.",
		"price": "Hinta (€)",
		"pricePlaceholder": "esim. 15",
		"priceNegotiable": "Hinta neuvoteltavissa",
		"shipsTo": "Toimitus",
		"shipsToOptions": {
			"pickup-only": "Nouto",
			"domestic": "Kotimaahan",
			"international": "Kansainvälisesti"
		},
		"country": "Maa",
		"selectCountry": "Valitse maa",
		"city": "Kaupunki / Alue",
		"selectCity": "Valitse kaupunki",
		"publish": "Julkaise ilmoitus",
		"publishing": "Julkaistaan…",
		"saveChanges": "Tallenna muutokset",
		"errors": {
			"invalidPrice": "Anna hinta, joka on suurempi kuin 0.",
			"cityRequired": "Valitse kaupunki tai alue."
		}
	},
	"review": {
		"labels": {
			"photos": "Kuvat",
			"discModel": "Kiekon malli",
			"discClassWeight": "Kiekkotyyppi & paino",
			"plastic": "Muovi",
			"flightNumbers": "Lentonumerot",
			"priceLocation": "Hinta & sijainti"
		},
		"photoSummary": "{{filled}} / {{total}} lisätty",
		"colorCount_one": "{{count}} väri",
		"colorCount_other": "{{count}} väriä",
		"notSet": "Ei asetettu — muokkaa napauttamalla",
		"autoFilled": "Automaattisesti täytetty"
	},
	"nav": {
		"back": "Takaisin",
		"next": "Seuraava",
		"nextArrow": "Seuraava →",
		"publishArrow": "Julkaise ilmoitus →",
		"saveArrow": "Tallenna →",
		"done": "Valmis"
	},
	"errors": {
		"discIdentityIncomplete": "Kiekon tiedot ovat puutteelliset. Palaa vaiheeseen 2.",
		"flightConditionIncomplete": "Lennot ja kunto ovat puutteelliset. Palaa vaiheeseen 3.",
		"publishFailed": "Ilmoituksen julkaisu epäonnistui. Yritä uudelleen.",
		"updateFailed": "Ilmoituksen päivitys epäonnistui. Yritä uudelleen."
	},
	"toasts": {
		"updated": "Ilmoitus päivitetty."
	}
}
